import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const Ctx = createContext(null);

function iso(d) { return d.toISOString().slice(0, 10); }

export function computeRange(preset) {
  const end = new Date();
  let start = new Date();
  if (preset === "7d") start.setDate(end.getDate() - 6);
  else if (preset === "30d") start.setDate(end.getDate() - 29);
  else if (preset === "90d") start.setDate(end.getDate() - 89);
  else if (preset === "month") start = new Date(end.getFullYear(), end.getMonth(), 1);
  return { start: iso(start), end: iso(end) };
}

export function DashboardProvider({ children }) {
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState("all");
  const [preset, setPreset] = useState("30d");
  const [range, setRange] = useState(computeRange("30d"));
  const [syncing, setSyncing] = useState(false);

  const loadBranches = useCallback(async () => {
    try {
      const { data } = await api.get("/branches");
      setBranches(data);
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => { loadBranches(); }, [loadBranches]);

  const applyPreset = (p) => {
    setPreset(p);
    if (p !== "custom") setRange(computeRange(p));
  };
  const setCustom = (start, end) => { setPreset("custom"); setRange({ start, end }); };

  const refreshData = () => window.dispatchEvent(new Event("dash-refresh"));

  const globalSync = async () => {
    setSyncing(true);
    try {
      await api.post("/sync");
      await loadBranches();
      refreshData();
      toast.success("All branches synced");
    } catch (e) {
      toast.error("Sync failed");
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Ctx.Provider value={{
      branches, branchId, setBranchId, preset, applyPreset, range, setCustom,
      syncing, globalSync, loadBranches, refreshData,
    }}>
      {children}
    </Ctx.Provider>
  );
}

export const useDashboard = () => useContext(Ctx);
